import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Box, Container } from '@mui/material';
import usePageBackground from '../hooks/usePageBackground';
import FadeItem from '../components/fadeItem';
import { useFadeInOnScroll } from '../theme/global';
import * as endPoints from '../assets/js/endpoints';
import * as utils from '../assets/js/utils';
import Loader from '../components/loader';

function ServiceSection({ service, index }) {
  const imgRef = useFadeInOnScroll();
  const even = index % 2 === 0;
  // const isFirst = index === 0;
  const bgColor = even ? '#FFFCE8' : '#C0DCBD';
const padding = {
    xs: '3em 2em',
    md: '3em 8em',
  };
  const paragraphs = Array.isArray(service.description)
    ? service.description
    : (service.description || '').split('\n');
    const color = even ? '#66ab5ea3' : 'var(--color-light-beige)';

  const TextBox = (
    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'justify' }}>
      <FadeItem
        text={<><span style={{ fontSize: '20px', color: color}}>CON </span><b style={{ fontSize: '30px', fontWeight: 700, color: color  }}>{service.name}</b></>}
        variant="h4"
        style={{ fontFamily: 'Raleway, sans-serif', fontWeight: 400, color: '#66ab5ea3', mb: 4, fontSize: '24px' }}
      />
      {paragraphs.map((t, idx) => (
        <FadeItem
          key={idx}
          text={t}
          style={{ fontFamily: 'Raleway, sans-serif', fontWeight: 400, fontSize: '1.125em', color: '#7a7442', mb: 2 }}
        />
      ))}
    </Box>
  );

  const ImageBox = service.image && (
    <Box
      ref={imgRef}
      component="img"
      src={utils.image_path(service.image)}
      alt={service.name}
      className="fade-up"
      sx={{
        flex: 1,
        width: '100%',
        maxWidth: '600px',
        borderRadius: '8px',
        boxShadow: 3,
        objectFit: 'cover',
        height: 'auto',
        maxHeight: '400px',
      }}
    />
  );

  return (
    <Container
      maxWidth={false}
      sx={{
        display: 'flex',
        // flexDirection: isFirst ? 'column' : { xs: 'column', md: 'row' },
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: 'center',
        padding,
        gap: 4,
        justifyContent: 'space-between',
        backgroundColor: bgColor,
      }}
    >
     {/*  {
      isFirst ? (
        <>
          {ImageBox}
          {TextBox}
        </>
      ) : */}
     { even ? ( 
        <>
          {TextBox}
          {ImageBox}
        </>
      ) : (
        <>
          {ImageBox}
          {TextBox}
        </>
      )}
    </Container>
  );
}

export default function HowHelp() {
  const [loading, setLoading] = useState(true);
  const [services, setServices] = useState([]);
  usePageBackground('howHelp-background-color');

  useEffect(() => {
    endPoints
      .getAllServices()
      .then((data) => {
        const list = Array.isArray(data) ? data : data?.data || [];
        setServices(list);
      })
      .finally(() => setLoading(false));
  }, []);

  const textInicio = [
    'Respira. CES es un lugar para encontrarte. Eres un todo. Tu cuerpo, tu mente y tu alma sois uno.',
    'Sabemos que no encuentras el tiempo. Hemos creado un lugar en el que descubrirás que puedes sanarte sin dejar de ser quien eres. Sin hacer grandes esfuerzos. Sin restar tiempo a tu vida, a tu familia. En un mismo espacio encontrarás profesionales que te guiarán en el camino hacia tu bienestar, acompañándote en cada paso, adaptándonos a tus necesidades.',
    'Somos un centro de bienestar integral orientado a la felicidad.',
  ];

  if (loading) return <Loader />;

  return (
    <>
      <Helmet>
        <title>Como Ayudamos | CES</title>
        <meta name="description" content="Descubre cómo puedes colaborar con nuestra organización." />
      </Helmet>
      <Box
        sx={{
          textAlign: 'center',
          // p: '2.5em',
          // my: '2.5em',
          minHeight: '100vh',
          rowGap: 6,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          overflow: 'hidden',
          width: '100%',
        }}
      >
        <Container sx={{ mt: 2, p: "3em 2em",
            m: 0, }}>
          <FadeItem
            text="Cómo te ayudamos"
            variant="h2"
            style={{ fontFamily: 'Great Vibes, cursive', fontWeight: 400, color: '#66ab5ea3', mb: 2 }}
          />
          {textInicio.map((text, index) => (
            <FadeItem
              key={index}
              text={text}
              style={{ fontFamily: 'Raleway, sans-serif', fontWeight: 400, fontSize: '1.125em', color: '#7a7442', mb: 2, minWidth: '100%' }}
            />
          ))}
        </Container>
        {services.map((srv, idx) => (
          <ServiceSection key={srv.id ?? idx} service={srv} index={idx} />
        ))}
      </Box>
    </>
  );
}
